import { exec, getApiToken } from '@src/apis/reware/utils';

import type { FetchVitalElementsExecVariables, FetchVitalElementsExecResponse } from './types';

export interface FetchVitalElementsArgs {
  partnerCode: string;
  token: string;
}

/**
 * Fetches vital elements for a partner using the getVitalElements query.
 * Returns an array of vital element tag strings (e.g., ["color", "size", "material"]).
 */
export const fetchVitalElements = async ({ partnerCode, token }: FetchVitalElementsArgs): Promise<string[]> => {
  const apiToken = await getApiToken(token);

  const query = `
    query getVitalElements(
      $token: String!
      $partnerCode: String
    ) {
      restUser(token: $token) {
        getVitalElements(partnerCode: $partnerCode) {
          vitalElements
          partnerCode
        }
      }
    }
  `;

  const data = await exec<FetchVitalElementsExecVariables, FetchVitalElementsExecResponse>(
    query,
    {
      variables: {
        token: apiToken,
        partnerCode,
      },
    }
  );

  const results = data.restUser.getVitalElements;
  return results?.[0]?.vitalElements ?? [];
};
